export default __webpack_public_path__ + "static/media/arrow-down.a28c443a.svg";